import React, { useEffect, useState, useRef } from "react";
import { CheckboxField } from "../Fields/CheckboxField";
import { RangeWrapper } from "./components/RangeRaperMobile";
import { useSelector, useDispatch } from "react-redux";
import {
  formatCurrency,
  formatCurrencyStipend,
  toggleClassicElementInArray,
  toggleElementInArray,
} from "../../helper";
import { fetchSearch } from "../../Redux/Actions/ProfileSteps";
import { useDebouncedSearchDispatch } from "../../helper/UseDebouncedSearchDispatch";
import { RESET_SEARCH } from "../../Redux/Actions/types";
const FilterComponent = ({ handleFilterChange, submitFilter, type }) => {
  const dispatch = useDispatch();
  const BASEPATH = "";
  const [selected, setSelected] = useState("job-type");
  const localFilter = useSelector((s) => s.jobBoard.localFilter);
  const [locationSearch, setLocationSearch] = useState("");
  const [companySearch, setCompanySearch] = useState("");
  const [searchItem, setSearchItem] = useState("");
  const locationFilter = useSelector(
    (s) => s.ProfileSteps.searchByField.locationFilter,
  );
  const companyFilter = useSelector(
    (s) => s.ProfileSteps.searchByField.companyFilter,
  );
  const locationRef = useRef(null);
  const companyRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        locationRef.current &&
        !locationRef.current.contains(event.target) &&
        locationFilter?.length > 0
      ) {
        setLocationSearch("");
        dispatch({ type: RESET_SEARCH });
      }

      if (
        companyRef.current &&
        !companyRef.current.contains(event.target) &&
        companyFilter?.length > 0
      ) {
        setCompanySearch("");
        dispatch({ type: RESET_SEARCH });
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dispatch, locationFilter, companyFilter]);
  useDebouncedSearchDispatch({
    value: locationSearch,
    dispatch,
    fetchAction: fetchSearch,
    search_type: "homeCity",
    context: "locationFilter",
  });
  useDebouncedSearchDispatch({
    value: companySearch,
    dispatch,
    fetchAction: fetchSearch,
    search_type: "companyName",
    context: "companyFilter",
  });
  const handleLocationSearch = (e) => {
    setSearchItem(e.target.ariaLabel);
    setLocationSearch(e.target.value);
  };
  const handleCompanySearch = (e) => {
    setSearchItem(e.target.ariaLabel);
    setCompanySearch(e.target.value);
  };
  const handleCheckBoxChange = (key, value) => {
    if (localFilter.hasOwnProperty(key)) {
      const newData = toggleElementInArray(localFilter?.[key], value);
      handleFilterChange({ [key]: [...newData] });
    } else {
      handleFilterChange({ [key]: [value] });
    }
  };
  const handleShortlistData = (key, value) => {
    const newData = toggleElementInArray(localFilter?.[key], value);
    handleFilterChange({ [key]: newData });
  };
  const handleClassicCheckBoxChange = (key, value) => {
    if (localFilter.hasOwnProperty(key)) {
      const newData = toggleClassicElementInArray(localFilter?.[key], value);
      handleFilterChange({ [key]: [...newData] });
    } else {
      handleFilterChange({ [key]: [value] });
    }
  };
  const handleSliderChange = (key, value) => {
    const [minimum, maximum] = value;
    handleFilterChange({ [key]: { minimum, maximum } });
  };

  const handleRadioChange = (key, value) => {
    handleFilterChange({ [key]: [value.object_name] });
  };
  const initialFetch = async (type, context, label) => {
    try {
      setSearchItem(label);
      await dispatch({ type: RESET_SEARCH });
      await dispatch(
        fetchSearch({
          search_type: type,
          search_char: "prominentdef",
          context: context,
        }),
      );
    } catch (err) {
      console.error(" search failed:", err);
    }
  };

  return (
    <div className="row main-modal-filter">
      <div className="filter-link-wrapper col-5 p-0">
        <div
          className="nav flex-column nav-pills"
          id="v-pills-tab"
          role="tablist"
          aria-orientation="vertical"
        >
          {type == "internship" && (
            <button
              className={`nav-link filter-ff d-flex ${selected == "job_types" ? "active" : ""}`}
              id={`v-pills-job_types-tab`}
              data-bs-toggle="pill"
              data-bs-target={`#v-pills-job_types`}
              type="button"
              role="tab"
              aria-controls={`v-pills-job_types`}
              aria-selected={selected == "job_types" ? "true" : "false"}
              onClick={() => setSelected("job_types")}
            >
              Job Type
              {localFilter?.job_types?.length > 0 && (
                <img
                  src={`${BASEPATH}/svg/check.svg`}
                  className="ms-auto"
                  width={16}
                />
              )}
            </button>
          )}
          <button
            className={`nav-link filter-ff d-flex ${selected == "job_locations" ? "active" : ""}`}
            id={`v-pills-job_locations-tab`}
            data-bs-toggle="pill"
            data-bs-target={`#v-pills-job_locations`}
            type="button"
            role="tab"
            aria-controls={`v-pills-job_locations`}
            aria-selected={selected == "job_locations" ? "true" : "false"}
            onClick={() => setSelected("job_locations")}
          >
            Job Location
            {localFilter?.job_locations?.length > 0 && (
              <img
                src={`${BASEPATH}/svg/check.svg`}
                className="ms-auto"
                width={16}
              />
            )}
          </button>
          <button
            className={`nav-link filter-ff d-flex ${selected == "pay_scale" ? "active" : ""}`}
            id={`v-pills-pay_scale-tab`}
            data-bs-toggle="pill"
            data-bs-target={`#v-pills-pay_scale`}
            type="button"
            role="tab"
            aria-controls={`v-pills-pay_scale`}
            aria-selected={selected == "pay_scale" ? "true" : "false"}
            onClick={() => setSelected("pay_scale")}
          >
            {type == "internship" ? "Stipend" : "Salary"}
            {localFilter?.pay_scale?.length > 0 && (
              <img
                src={`${BASEPATH}/svg/check.svg`}
                className="ms-auto"
                width={16}
              />
            )}
          </button>
          <button
            className={`nav-link filter-ff d-flex ${selected == "company_list" ? "active" : ""}`}
            id={`v-pills-company_list-tab`}
            data-bs-toggle="pill"
            data-bs-target={`#v-pills-company_list`}
            type="button"
            role="tab"
            aria-controls={`v-pills-company_list`}
            aria-selected={selected == "company_list" ? "true" : "false"}
            onClick={() => setSelected("company_list")}
          >
            Company Name
            {localFilter?.company_list?.length > 0 && (
              <img
                src={`${BASEPATH}/svg/check.svg`}
                className="ms-auto"
                width={16}
              />
            )}
          </button>
        </div>
      </div>

      <div className="col p-0">
        <div className="filter-link-content">
          <div className="tab-content" id="v-pills-tabContent">
            <div
              className={`tab-pane fade ${selected == "job_types" ? "show active" : ""} px-3 pt-4`}
              id={`v-pills-job_types`}
              role="tabpanel"
              aria-labelledby={`v-pills-roleType-tab`}
            >
              {[
                { label: "Internship 2 months", value: "INTERNSHIPTWOMONTHS" },
                { label: "Internship 6 months", value: "INTERNSHIPSIXMONTHS" },
              ].map((item, idx) => (
                <CheckboxField
                  onChange={(val) =>
                    handleClassicCheckBoxChange("job_types", item.value)
                  }
                  key={idx}
                  checked={localFilter?.job_types?.some(
                    (selectedItem) => selectedItem === item.value,
                  )}
                  id={item.value}
                  label={item.value}
                />
              ))}
            </div>
            <div
              className={`tab-pane fade ${selected == "job_locations" ? "show active" : ""} px-3 pt-4`}
              id={`v-job_locations`}
              role="tabpanel"
              aria-labelledby={`v-job_locations-tab`}
              ref={locationRef}
            >
              {selected == "job_locations" && (
                <form>
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control search-box bg-white mb-3"
                      onFocus={() =>
                        initialFetch(
                          "homeCity",
                          "locationFilter",
                          "job_locations",
                        )
                      }
                      value={
                        searchItem == "job_locations" ? locationSearch : ""
                      }
                      onChange={(e) => handleLocationSearch(e)}
                      placeholder="Search"
                      aria-label="job_locations"
                      aria-describedby="Search by name"
                    />
                  </div>
                </form>
              )}
              {searchItem == "job_locations"
                ? locationFilter.map((location, index) => {
                  const isChecked = localFilter?.job_locations?.some(
                    (selectedItem) => selectedItem === location.object_name,
                  );

                  return (
                    <label
                      key={location.object_id || index}
                      className="checkbox-container form-checkbox mb-3"
                    >
                      <input
                        type="checkbox"
                        className="form-check-input"
                        value={location.object_name}
                        checked={isChecked}
                        onChange={() =>
                          handleRadioChange("job_locations", location)
                        }
                      />
                      <span className="checkboxmark form-check-label">
                        {location.object_name}
                      </span>
                    </label>
                  );
                })
                : localFilter?.job_locations?.map((item, idx) => {
                  const isChecked = localFilter?.job_locations?.some(
                    (selectedItem) => selectedItem,
                  );

                  return (
                    <CheckboxField
                      onChange={(val) =>
                        handleRadioChange("job_locations", item)
                      }
                      key={item}
                      checked={isChecked}
                      id={item}
                      label={item}
                    />
                  );
                })}
            </div>
            <div
              className={`tab-pane fade ${selected == "job_locations" ? "show active" : ""} px-3 pt-4`}
              id={`v-pills-job_locations`}
              role="tabpanel"
              aria-labelledby={`v-pills-job_locations-tab`}
            >
              {localFilter?.job_locations?.object_details?.map((item, idx) => (
                <CheckboxField
                  onChange={(val) => handleCheckBoxChange("job_locations", val)}
                  key={idx}
                  checked={localFilter?.job_locations?.object_details?.includes(
                    item,
                  )}
                  id={item.object_name}
                  label={item.object_name}
                />
              ))}
            </div>
            <div
              className={`tab-pane fade ${selected == "pay_scale" ? "show active" : ""} px-3 pt-4`}
              id={`v-pills-pay_scale`}
              role="tabpanel"
              aria-labelledby={`v-pills-pay_scale-tab`}
            >
              {" "}
              {type == "fulltime" ? (
                <RangeWrapper
                  min={600000}
                  max={10000000}
                  minValue={formatCurrency(
                    localFilter?.pay_scale?.minimum || 600000,
                  )}
                  maxValue={formatCurrency(
                    localFilter?.pay_scale?.maximum || 10000000,
                  )}
                  value={[
                    localFilter?.pay_scale?.minimum || 600000,
                    localFilter?.pay_scale?.maximum || 10000000,
                  ]}
                  onChange={(value) => {
                    const roundedValue = value.map(
                      (v) => Math.round(v / 100000) * 100000,
                    );
                    handleSliderChange("pay_scale", roundedValue);
                  }}
                  startingType=""
                  endingType=""
                  startingPlaceholder={formatCurrency(
                    localFilter?.pay_scale?.minimum || 600000,
                  )}
                  endingPlaceholder={formatCurrency(
                    localFilter?.pay_scale?.maximum || 10000000,
                  )}
                  minStep={100000}
                />
              ) : (
                <RangeWrapper
                  min={0}
                  max={100000}
                  minValue={formatCurrencyStipend(
                    localFilter?.pay_scale?.minimum || 0,
                  )}
                  maxValue={formatCurrencyStipend(
                    localFilter?.pay_scale?.maximum || 100000,
                  )}
                  value={[
                    localFilter?.pay_scale?.minimum || 0,
                    localFilter?.pay_scale?.maximum || 100000,
                  ]}
                  onChange={(value) => {
                    const roundedValue = value.map(
                      (v) => Math.round(v / 1000) * 1000,
                    );
                    handleSliderChange("pay_scale", roundedValue);
                  }}
                  startingType=""
                  endingType=""
                  startingPlaceholder={formatCurrencyStipend(
                    localFilter?.pay_scale?.minimum || 0,
                  )}
                  endingPlaceholder={formatCurrencyStipend(
                    localFilter?.pay_scale?.maximum || 100000,
                  )}
                  minStep={1000}
                />
              )}
            </div>
            <div
              className={`tab-pane fade ${selected == "company_list" ? "show active" : ""} px-3 pt-4`}
              id={`v-pills-company_list`}
              role="tabpanel"
              aria-labelledby={`v-pills-company_list-tab`}
            >
              {selected == "company_list" && (
                <form>
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control search-box bg-white mb-3"
                      onFocus={() =>
                        initialFetch(
                          "companyName",
                          "companyFilter",
                          "companyFilter",
                        )
                      }
                      value={searchItem == "companyFilter" ? companySearch : ""}
                      onChange={(e) => handleCompanySearch(e)}
                      placeholder="Search"
                      aria-label="companyFilter"
                      aria-describedby="Search by name"
                    />
                  </div>
                </form>
              )}
              {searchItem == "companyFilter"
                ? companyFilter.map((location, index) => {
                  const isChecked =
                    localFilter?.company_list?.object_details?.some(
                      (selectedItem) =>
                        selectedItem.object_id === location.object_id,
                    );
                  return (
                    <label
                      key={location.object_id || index}
                      className="checkbox-container form-checkbox mb-3"
                    >
                      <input
                        type="checkbox"
                        className="form-check-input"
                        value={location.object_name}
                        checked={isChecked}
                        onChange={() =>
                          handleCheckBoxChange("company_list", location)
                        }
                      />
                      <span className="checkboxmark form-check-label">
                        {location.object_name}
                      </span>
                    </label>
                  );
                })
                : localFilter?.company_list?.map((item, idx) => {
                  if (
                    item?.object_name !== "" &&
                    item?.object_string !== ""
                  ) {
                    const isChecked = localFilter?.company_list?.some(
                      (selectedItem) =>
                        selectedItem.object_id === item.object_id,
                    );

                    return (
                      <CheckboxField
                        onChange={(val) =>
                          handleShortlistData("company_list", item)
                        }
                        key={item.object_id}
                        checked={isChecked}
                        id={item.object_id}
                        label={item.object_name}
                      />
                    );
                  }
                  return null;
                })}
            </div>
          </div>
        </div>
        <div className="text-end mobile-filter-button">
          <button
            onClick={submitFilter}
            className="quicksand site-btn blue-btn"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterComponent;
